export default {
  methods: {
    propertyModified () {
      const isPropertyModified = this.isPropertyModified()

      if (!isPropertyModified) return ''

      const value = this.getValue(this.dataOriginal)

      return value === undefined ? '' : `(${value})`
    },

    isPropertyModified () {
      if (!this.dataOriginal || !this.dataForm) return false

      const valueOriginal = this.getValue(this.dataOriginal)
      const valueForm = this.cleanValue(this.getValue(this.dataForm))

      if (valueOriginal === undefined && !valueForm) return false
      if (valueOriginal === null && !valueForm) return false

      return valueOriginal !== valueForm
    },

    getValue (data) {
      return this.index >= 0 ? data[this.property][this.index] : data[this.property]
    },

    cleanValue (value) {
      if (typeof value !== 'string') return value
      if (this.caseSensitive) return value
      return value.toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/propertyManage.js